import { useQuery } from '@tanstack/react-query';
import { GetAllRegisteredConventionDocuments } from '../helper/apiHelper';
import { QUERY_KEYS } from '../Constants/queryKeys';

export const useConventions = () => {
  return useQuery({
    queryKey: QUERY_KEYS.CONVENTIONS,
    queryFn: GetAllRegisteredConventionDocuments,
    select: (data) => {
      return [...data].sort((a, b) => {
        return (
          new Date(b.registrationDate).getTime() -
          new Date(a.registrationDate).getTime()
        );
      });
    },
  });
};
